import {
  ADD_DEVICE_TYPE_REQUEST,
  ADD_DEVICE_TYPE_SUCCESS,
  ADD_DEVICE_TYPE_FAILURE,
  GET_DEVICE_TYPE_REQUEST,
  GET_DEVICE_TYPE_SUCCESS,
  GET_DEVICE_TYPE_FAILURE,
  DELETE_DEVICE_TYPE_REQUEST,
  DELETE_DEVICE_TYPE_SUCCESS,
  DELETE_DEVICE_TYPE_FAIL,
} from "../Actions/DeviceTypeAction";

const initialState = {
  loading: false,
  success: false,
  error: null,
  createdDeviceType: null,
  data:[],
  deviceTypes: [],
};

const DeviceTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_DEVICE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case ADD_DEVICE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        createdDeviceType: action.payload,
      };

    case ADD_DEVICE_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case GET_DEVICE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
         data:[],
      };
     case GET_DEVICE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
      };
      case GET_DEVICE_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        data:[],
        error: action.payload,
      };
        case DELETE_DEVICE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_DEVICE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        deviceTypes: state.deviceTypes.filter(
          (item) => item.id !== action.payload
        ),
      };

    case DELETE_DEVICE_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default DeviceTypeReducer;